<template>
    <transition name="fade">
        <div class="quick-pay-result">
            <div class="main-container">
                <img src="../../../assets/images/icon-success-green.png" alt="" class="success-icon">
                <span class="success-slogan">下单成功 感谢您的支持</span>
                <span class="success-tips">您的服装定制需求已提交,我们将尽快与您联系确认细节</span>
                <div class="order-info">
                    <div class="info">
                        <div class="pay-amount">
                            <div class="label">实付金额:</div>
                            <div class="value">  ¥{{ (info.amount || 0) | price_format }}</div>
                        </div>
                        <div class="pay-address">收件信息:{{ info.address }}</div>
                    </div>
                </div>
                <div class="btn-box">
                    <div class="view-btn" @click="$router.push({name:'OrderDetail',query:{uuid:info.order_uuid}})">查看订单</div>
                    <div class="back-btn" @click="$router.push({name:'Index'})">返回首页</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    name:"QuickPayResult",
    data(){
        return{}
    },
    props:{
        info:{
            type:Object,
            default:function(){
                return {
                    order_uuid:'',
                    amount:0,
                    address:''
                }
            }
        }
    },
    mounted(){},
    methods:{}
}
</script>
<style lang="scss" scoped>
.quick-pay-result{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    display:flex;
    align-items:center;
    justify-content:center;
    .main-container{
        width:930px;
        border-radius:10px;
        background:#ffffff;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        .success-icon{
            width:92px;
            height:92px;
            margin-top:70px;
        }
        .success-slogan{
            margin-top:33px;
            color:#3bb46d;
            font-size:24px;
            font-weight:bold;
        }
        .success-tips{
            margin-top:16px;
            color:#666666;
            font-size:16px;
        }
        .order-info{
            width:100%;
            padding:0 40px;
            margin-top:53px;
            .info{
                background:#f7f7f7;
                display:flex;
                align-items:center;
                flex-wrap:wrap;
                padding:35px 30px;
                .pay-amount{
                    display:flex;
                    align-items:baseline;
                    column-gap:10px;
                    width:100%;
                    .label{
                        color:#1a1a1a;
                        font-size:14px;
                        font-weight:bold;
                    }
                    .value{
                        color:#fa3d5a;
                        font-size:24px;
                        font-weight: bold;
                    }
                }
                .pay-address{
                    width:100%;
                    color:#666666;
                    font-size:14px;
                    margin-top:20px;
                }
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            justify-content:center;
            column-gap:20px;
            margin-top:98px;
            margin-bottom:112px;
            .view-btn{
                background:#fa3d5a;
                border-radius:5px;
                width:120px;
                height:42px;
                text-align:center;
                line-height:42px;
                color:#ffffff;
                cursor:pointer;
            }
            .back-btn{
                background:#ffffff;
                border-radius:5px;
                width:120px;
                height:42px;
                text-align:center;
                line-height:42px;
                color:#fa3d5a;
                cursor:pointer;
                border:1px solid #fa3d5a;   
            }
        }
    }
}
</style>